import * as actions from './actions'

const PetStore = {
  namespaced: true,
  state: {},
  actions
}

export default PetStore
